<div class="controls-header">
  <app-terug-knop-new [viewmodel]="viewmodel?.terugKnopViewmodel"></app-terug-knop-new>
  <app-vak-onderwijs-switch-new [viewmodel]="viewmodel?.vakOnderwijsSwitchViewmodel" [navigeerbaar]="(isNavigeerbaar$ | async)"></app-vak-onderwijs-switch-new>
  <div class="box"></div>
</div>
